import { PARENTHESIS_MATCH_REGEX } from '../../constants';

type SearchTermValues = {
  city: string;
  country: string;
};

const extractCityFromParenthesis = (searchTerm: string) => {
  const regex = PARENTHESIS_MATCH_REGEX;
  const match = searchTerm.match(regex);
  if (!match) {
    return null;
  }
  const [, country, city] = match;
  return { city, country } as SearchTermValues;
};

export default extractCityFromParenthesis;
